<script>
     import { PageLoading } from "../../../Components/Common/index.svelte";

     export let title;
     export let isLoadingData = false;
     export let disableToggle = false;
     export let wrapperClass = "";

     let isContainerOpen = true;

     // HELPER FUNCTIONS
     const _toggleShowHideContainer = () => {
          if (!disableToggle) isContainerOpen = !isContainerOpen;
     };
</script>

<div
     class={`transition flex flex-col w-full lg:flex-row ${wrapperClass} ${
          isContainerOpen ? "" : "max-h-[50px]"
     }`}
>
     <div
          class="flex flex-1 h-full card bg-white rounded-lg border {isContainerOpen
               ? 'overflow-visible'
               : ''}"
     >
          <div
               class="flex gap-x-4 pr-2 text-white bg-gradient-to-b from-primary to-secondary items-center rounded-tl-lg rounded-tr-lg h-[50px]"
               on:click|preventDefault={_toggleShowHideContainer}
          >
               <p class="font-bold px-2 py-4">{title}</p>
          </div>

          {#if isLoadingData}
               <div class="flex flex-1 items-center justify-center h-64">
                    <PageLoading />
               </div>
          {:else}
               <slot />
          {/if}
     </div>
</div>

<style>
     .transition {
          transition: 0.5s linear;
     }
</style>
